import { TemplateJobProjectionResponse } from "../../../../interfaces/adminUser/adminRecurringTaskStats/AdminRecurringTaskJobStats";

interface CalendarProps {
    year: number;
    month: number;
    data: TemplateJobProjectionResponse;
    onDayClick: (day: string) => void;
}

const CalendarView: React.FC<CalendarProps> = ({ year, month, data, onDayClick }) => {
    // Calculate calendar grid spacing
    const firstDayOfMonth = new Date(year, month - 1, 1).getDay(); // 0 = Sunday
    const daysInMonth = new Date(year, month, 0).getDate();
    
    const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);
    const blanksArray = Array.from({ length: firstDayOfMonth }, (_, i) => i);

    return (
        <div className="bg-white rounded-lg shadow">
            {/* Days of Week Header */}
            <div className="grid grid-cols-7 border-b bg-gray-100 text-gray-600 font-semibold text-center py-2">
                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => <div key={d}>{d}</div>)}
            </div>

            {/* Calendar Grid */}
            <div className="grid grid-cols-7 auto-rows-fr">
                {/* Empty cells for previous month */}
                {blanksArray.map(i => <div key={`blank-${i}`} className="h-32 border-b border-r bg-gray-50"></div>)}

                {/* Actual Days */}
                {daysArray.map(day => {
                    const dayKey = day.toString();
                    const tasks = data.dailyProjections[dayKey] || [];
                    const count = tasks.length;
                    
                    return (
                        <div 
                            key={day} 
                            onClick={() => onDayClick(dayKey)}
                            className={`h-32 border-b border-r p-2 cursor-pointer transition hover:bg-blue-50 relative group ${count > 0 ? 'bg-white' : 'bg-gray-50/50'}`}
                        >
                            <span className="font-semibold text-gray-700">{day}</span>
                            
                            {count > 0 && (
                                <div className="mt-2">
                                    <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full font-bold">
                                        {count} Scheduled
                                    </span>
                                    {/* Quick Preview of first 2 items */}
                                    <div className="mt-1 text-xs text-gray-500 truncate">
                                        • {tasks[0].templateTitle}
                                    </div>
                                    {count > 1 && (
                                        <div className="text-xs text-gray-500 truncate">
                                            • {tasks[1].templateTitle}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CalendarView;